import cx from "classnames";
import React from "react";

import { StateCallbacks } from "../../state";
import { Page as PageType, State } from "../../types";
import { ScrollToElement } from "../ScrollToElement";
import { Page } from "./Page";

type Props = Readonly<{
  confirmTableSelection: boolean;
  disableTableSelectionConfirmation: () => void;
  onSelectBlock: StateCallbacks["onSelectBlock"];
  onAddCorrections: StateCallbacks["onAddCorrections"];
  setShowReferences: (blockId: string) => void;
  state: State;
  viewWidth: number;
  zoom: number;
}>;

const isGraphicalPage = (page: PageType): page is Required<PageType> => {
  return page.src !== undefined && page.height !== undefined && page.width !== undefined;
};

export const Pages = ({
  confirmTableSelection,
  disableTableSelectionConfirmation,
  onSelectBlock,
  onAddCorrections,
  setShowReferences,
  state,
  viewWidth,
  zoom,
}: Props) => {
  const { activeValue, blocks, pages, values } = state;
  let idRef: string | null = null;
  if (activeValue && values[activeValue]) {
    idRef = values[activeValue].idRef;
  }
  const selector =
    activeValue in values && values[activeValue].idRef ? values[activeValue].idRef : null;
  return (
    <ScrollToElement
      activeDataPoint={state.scrollToBlock}
      className={cx("pages", { selecting: activeValue in values })}
      selector={selector}
    >
      {pages.map((p, index) => {
        if (!isGraphicalPage(p)) {
          return null;
        }
        let activeBlockId = null;
        if (idRef !== null && blocks[idRef] && blocks[idRef].page === index) {
          activeBlockId = idRef;
        }
        return (
          <Page
            activeBlockId={activeBlockId}
            blocks={blocks}
            confirmTableSelection={confirmTableSelection}
            containerWidth={viewWidth}
            disableTableSelectionConfirmation={disableTableSelectionConfirmation}
            key={`page-${index}`}
            onSelectBlock={onSelectBlock}
            onAddCorrections={onAddCorrections}
            page={p}
            setShowReferences={setShowReferences}
            zoom={zoom}
          />
        );
      })}
    </ScrollToElement>
  );
};

Pages.displayName = "Pages";
